import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { formatCell } from "src/app/utils/common";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import {
  DeleteDpParams,
  SetDpParams,
} from "src/app/store/actions/global-subheader.actions";
import { faBook } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-drug-page-grid",
  templateUrl: "./drug-page-grid.component.html",
  styleUrls: ["./drug-page-grid.component.scss"],
})
export class DrugPageGridComponent implements OnInit {
  @Input() serviceFunction: string;
  @Input() inReverseOrder = false;
  @Input() dataSettings;
  @Input() drugResearchParameters: any[] = [];
  @Output() onDataSourceChanged: EventEmitter<number> = new EventEmitter();
  @Output() onResearchIconClick: EventEmitter<any> = new EventEmitter();
  @Output() showResearchParameterOnGrid: EventEmitter<any> = new EventEmitter();
  routeSubscriber: Subscription;
  dpCallSubscriber: Subscription;
  cTagId = 0;
  companyId = 0;
  ticker = "";
  dataObservable: Observable<any>;
  dataSource: any = [];
  periodList = [];
  displayColumns = ["name", "currency_magnitude"];
  forecastPeriodData = {};
  consolidatedDP = 0;
  book = faBook;
  showResearchPopup: boolean = false;

  customSkeletonConfig = {
    skeletonType: "grid",
    config: {
      grid: {
        count: {
          row: 4,
          column: 5,
        },
        bordered: true,
      },
    },
  };
  selectedCell: string;
  selectedRow: any;
  constructor(
    private dataService: PharmaDataService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.routeSubscriber = this.route.params.subscribe((param) => {
      try {
        if (param.cTagId) {
          this.cTagId = parseInt(param.cTagId);
          this.makeDataCall(this.cTagId);
        } else {
          console.error("Ctagid is mandatory in route param");
        }
      } catch (e) {
        console.error("Invalid ctagid ", e);
      }
    });
  }

  makeDataCall(cTagId) {
    if (!this.dataSettings) {
      console.error("Data Settings is not present.");
      return;
    }
    this.selectedCell = "";
    this.selectedRow = 0;
    this.store.dispatch(new DeleteDpParams());
    this.dataObservable = this.dataService[this.serviceFunction]({
      ctagid: cTagId,
      currency: this.dataSettings.currency,
      viewby: this.dataSettings.view_by[0],
      revision: this.dataSettings.revision,
      period: this.dataSettings.periodData.period,
      period_type: this.dataSettings.periodData.period_type,
      period_basis: this.dataSettings.periodData.period_basis,
    });
    this.dataObservable["functionName"] = this.serviceFunction;
    this.periodList = [...this.dataSettings.periodData.period];
    this.displayColumns = ["name", "currency_magnitude"].concat(
      this.periodList,
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.dataSettings && changes.dataSettings.currentValue) {
      this.makeDataCall(this.cTagId);
    }
    if (changes && changes.drugResearchParameters) {
      this.addResearchParameters();
    }
  }

  formatCellValue(metaData, value, lineType) {
    const newVal = formatCell(
      value,
      "",
      metaData.unit,
      lineType && this.dataSettings.view_by[0] !== "revision"
        ? "values"
        : this.dataSettings.view_by[0],
    );
    return newVal;
  }

  formatRow(row) {
    if (!row.period_data || !row.meta_data) {
      return row;
    }
    const newRow = { ...row };
    newRow["period_data_formatted"] = {};
    this.periodList.forEach((period) => {
      if (row.period_data[`${period}`] !== undefined) {
        const newVal = this.formatCellValue(
          row.meta_data,
          row.period_data[`${period}`],
          row.line_type,
        );
        newRow["period_data_formatted"][`${period}`] = newVal;
      }
    });
    return newRow;
  }

  loadFormulaBar(dataPointObj, period) {
    this.selectedCell = "";
    this.selectedRow = 0;

    this.dataService.changeDataPoint(
      dataPointObj,
      `${dataPointObj.dapparameter.toString()}|${period}`,
    );

    if (
      dataPointObj.period_data[`${period}`] === "-" ||
      dataPointObj.period_data[`${period}`] === null ||
      dataPointObj.period_data[`${period}`] === undefined
    ) {
      this.store.dispatch(new DeleteDpParams());
      return;
    }

    const payload = {
      company_id: this.companyId,
      period: period,
      dapparameterid: dataPointObj.dapparameter,
      period_basis: this.dataSettings.periodData.period_basis,
      period_type: this.dataSettings.periodData.period_type,
      growthType: dataPointObj.line_type
        ? encodeURI(dataPointObj.line_type === "values" ? "Analytics" : "YoY%")
        : encodeURI(
            this.dataSettings.view_by[0] === "values" ? "Analytics" : "YoY%",
          ),
      viewby: dataPointObj.line_type
        ? dataPointObj.line_type
        : this.dataSettings.view_by[0],
      revision: this.dataSettings.revision,
    };
    if (payload.growthType !== "Analytics") {
      this.store.dispatch(new DeleteDpParams());
      return;
    }

    this.selectedRow = dataPointObj.id;
    this.selectedCell = `${dataPointObj.dapparameter.toString()}|${period}|${
      dataPointObj.id
    }`;
    // fetch data for param call
    this.dpCallSubscriber = this.dataService
      .getDpCallDetails(payload)
      .subscribe((resp) => {
        const today = new Date();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        const yyyy = today.getFullYear();
        const ticker = this.ticker;

        const dpParams = {
          dp: `${resp.data.rid}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
          cut: "NMV",
          ticker: ticker,
          source: "consensus",
          growthType: dataPointObj.line_type
            ? encodeURI(
                dataPointObj.line_type === "values" ? "Analytics" : "YoY%",
              )
            : encodeURI(
                this.dataSettings.view_by[0] === "values"
                  ? "Analytics"
                  : "YoY%",
              ),
          shouldLog: true,
          revision: this.dataSettings.revision,
          period: period,
          dapparameterId: resp.data.dapparameterid,
          extras: `${resp.data.rid}|${period}`, //"16151916582|CY-2020"
        };
        if (resp.data.is_forecast === false) {
          dpParams["source"] = "va actuals";
        } else {
          dpParams["source"] = "consensus";
        }

        if (dpParams.growthType === "YoY%") {
          dpParams["historical_focus"] = "VA Actuals";
        }

        if (this.dataSettings.currency !== "Base") {
          dpParams["currency"] = this.dataSettings.currency;
        }
        this.store.dispatch(new SetDpParams(dpParams));
      });
  }

  onDataResolved(resp) {
    this.companyId = resp.companyid;
    this.ticker = resp.ticker;
    this.forecastPeriodData = resp.forecast_period_data;
    this.consolidatedDP = resp.consolidated_dpid;
    const rows = [];
    const sortedIds = resp.sorted_ids;
    let index = 0;
    sortedIds.forEach((id) => {
      const mainRow = resp.data[id];
      let newRow = this.formatRow(mainRow);
      newRow["id"] = `${index}`;
      newRow["doBold"] = true;
      index++;
      rows.push(newRow);
      if (mainRow.children && mainRow.children.length) {
        const childRows = this.inReverseOrder
          ? mainRow.children.reverse()
          : mainRow.children;
        childRows.forEach((child) => {
          if (resp.data[child]) {
            newRow = this.formatRow(resp.data[child]);
            if (newRow["indentation"] === undefined) {
              newRow["indentation"] = 1;
            }
            newRow["id"] = `${index}`;
            newRow["id"] = `${index}`;
            index++;
            rows.push(newRow);
          }
        });
      }
    });

    if (this.serviceFunction === "getRelatedMetricsData") {
      rows.forEach((element, index) => {
        if (rows[index].shortname) {
          rows[index]["doBold"] = true;
        }
        if (index > 0) {
          if (rows[index - 1].indentation > rows[index].indentation) {
            rows[index]["doBold"] = true;
          }
        }
        if (this.consolidatedDP === rows[index].dapparameter) {
          rows[index]["doBold"] = true;
        }
      });

      for (let i = 0; i < rows.length - 1; i++) {
        const previousSortOrder = rows[i]["sortorder"];
        const nextSortOrder = rows[i + 1]["sortorder"];

        if (nextSortOrder - previousSortOrder > 1) {
          const blankRow = {
            name: "",
            indentation: "",
            sortorder: nextSortOrder - 1,
            meta_data: {
              unit: "",
              magnitude: "",
              currency: "",
            },
            period_data: {
              "FY-2021": null,
              "FY-2022": null,
              "FY-2023": null,
              "FY-2024": null,
              "FY-2025": null,
              "FY-2026": null,
              "FY-2027": null,
              "FY-2028": null,
              "FY-2029": null,
              "FY-2030": null,
            },
            dapparameter: null,
          };

          rows.splice(i + 1, 0, blankRow);
        }
      }
    }
    for (const index in rows) {
      if (!("isResearchIconShow" in rows[index])) {
        rows[index]["isResearchIconShow"] = false;
      }
    }
    this.dataSource = rows;
    this.onDataSourceChanged.emit(this.dataSource.length);
    this.addResearchParameters();
  }

  ngOnDestroy() {
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
  }

  addResearchParameters() {
    if (this.drugResearchParameters.length > 0) {
      this.showResearchParameterOnGrid.emit(this.dataSource);
    }
  }

  getDSMDOcumentDetails(dapparameterId) {
    const selectedParameter = this.drugResearchParameters.find(
      (x) => x.parameterid === parseInt(dapparameterId),
    );
    const dapParamObj = {
      parameterid: selectedParameter["parameterid"],
      drugid: this.cTagId,
    };
    dapParamObj["brokers"] = selectedParameter.documents.map((x) => x.orgid);
    this.onResearchIconClick.emit(dapParamObj);
  }
}
